<template>
  <header class="header">
    <div v-if="this.$store.getters.getFormChangeState" class="grid-container">
      <div class="cell auto text-center">
        <div class="callout warning callout--fixed-header">{{ $t('weeks.warning.changesnotsaved') }}</div>
      </div>
    </div>
    <div class="header__wrapper">
      <button role="button" class="nav-toggle" title="Menu" tabindex="-1">
        <span class="bar"></span>
      </button>
      <router-link class="logo" :to="{ name : 'home' }" :title="$t('nav.logo')" tabindex="-1">
        <img src="/assets/img/as-logo.svg" alt="AS Asphaltbau" />
      </router-link>
      <nav class="navigation navigation--header">
        <ul v-if="$store.getters.userIsAdmin">
          <li v-if="$store.getters.userHasPermission('customer_list')">
            <router-link
              :to="{ name : 'customers' }"
              :title="$t('nav.customers')"
              tabindex="-1"
            >{{ $t('nav.customers') }}</router-link>
          </li>
          <li v-if="$store.getters.userHasPermission('project_list')">
            <router-link
              :to="{ name : 'projects' }"
              :title="$t('nav.projects')"
              tabindex="-1"
            >{{ $t('nav.projects') }}</router-link>
          </li>
          <li v-if="$store.getters.userIsAdmin">
            <router-link
              :to="{ name : 'tours' }"
              :title="$t('nav.tours')"
              tabindex="-1"
            >{{ $t('nav.tours') }}</router-link>
          </li>
          <li v-if="$store.getters.userIsAdmin">
            <router-link
              :to="{ name : 'weeks' }"
              :title="$t('nav.weeks')"
              tabindex="-1"
            >{{ $t('nav.weeks') }}</router-link>
          </li>
          <li v-if="$store.getters.userIsAdmin">
            <router-link
              :to="{ name : 'projectmap' }"
              :title="$t('nav.projectmap')"
              tabindex="-1"
            >{{ $t('nav.projectmap') }}</router-link>
          </li>
          <li v-if="$store.getters.userHasPermission('mixingplant_list')">
            <router-link
              :to="{ name : 'search-mixingplants' }"
              :title="`Mischanlagen`"
              tabindex="-1"
            >Mischanlagen</router-link>
          </li>
          <li v-if="$store.getters.userCanAccessKiMvp">
            <router-link
              :to="{ name : 'project-planning-export' }"
              :title="$t('nav.projectplanningexport')"
              tabindex="-1"
            >{{ $t('nav.projectplanningexport') }}</router-link>
          </li>
        </ul>
        <ul v-else-if="$store.getters.userHasPermission('customer_view')">
          <li>
            <router-link
              :to="{ name : 'customers-view-customer', params : { customer : $store.getters.getUser.customer.id } }"
              :title="$t('nav.customer')"
              tabindex="-1"
            >{{ $t('customers.overview') }}</router-link>
          </li>
          <li v-if="$store.getters.userHasPermission('project_list')">
            <router-link
              :to="{ name : 'customers-view-customer-projects', params : { customer : $store.getters.getUser.customer.id } }"
              :title="$t('nav.projects')"
              tabindex="-1"
            >{{ $t('nav.projects') }}</router-link>
          </li>
        </ul>
      </nav>
      <div class="header__search" v-if="$store.getters.getUser.loggedin === true">
        <form action name="search-form" class="header__search__form" autocomplete="off">
          <input
            type="text"
            name="searchvalue"
            v-model="search"
            @keyup="onUpdateSearch()"
            tabindex="-1"
          />
          <button role="button" type="submit" :title="$t('search')" tabindex="-1">{{ $t('search') }}</button>
        </form>
        <div
          class="header__search__suggestions"
          v-if="!searchIsEmpty"
          :class="{'is-loading' : searchLoading}"
        >
          <template v-if="searchItems.length === 0 && !searchLoading">
            <p>{{ $t('search.empty') }}</p>
          </template>
          <div v-else v-for="(item, index) in searchItems" :key="index">
            <template v-if="item.results">
              <h2>{{ item.label }}</h2>
              <ul template v-for="(result, index) in item.results" :key="index">
                <li>
                  <router-link
                    :to="result.router"
                    :title="result.title"
                    @click.native="onSearchItemClick"
                    tabindex="-1"
                  >{{ result.title }}</router-link>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
      <div class="header__options">
        <v-header-notifications v-if="$store.getters.getUser.loggedin === true" />
        <div class="header__options__item">
          <button
            role="button"
            class="profile"
            :title="$t('nav.account')"
            tabindex="-1"
          >{{ $t('nav.account') }}</button>
          <div class="header__dropdown">
            <div class="header__dropdown__wrapper">
              <nav class="profile-navigation profile-navigation--header-dropdown on">
                <ul>
                  <template
                    v-if="$store.getters.getUser.loggedin === true && $store.getters.userHasPermission('profile')"
                  >
                    <li>
                      <router-link
                        :to="{ name : 'account-update-profile' }"
                        :title="$t('account.profile.update')"
                        tabindex="-1"
                      >
                        {{ $t('account.profile.update') }}
                        <span class="icon icon--edit"></span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name : 'account-update-password' }"
                        :title="$t('account.profile.password.update')"
                        tabindex="-1"
                      >
                        {{ $t('account.profile.password.update') }}
                        <span class="icon icon--edit"></span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name : 'logout' }"
                        :title="$t('nav.logout')"
                        tabindex="-1"
                      >
                        {{ $t('nav.logout') }}
                        <span class="icon icon--logout"></span>
                      </router-link>
                    </li>
                  </template>
                  <template v-else>
                    <li>
                      <router-link :to="{ name : 'login' }" :title="$t('nav.login')" tabindex="-1">
                        {{ $t('nav.login') }}
                        <span class="icon icon--login"></span>
                      </router-link>
                    </li>
                  </template>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import HeaderNotifications from "./HeaderNotifications";
import _ from "lodash";

export default {
  data() {
    return {
      user: this.$store.getters.getUser,
      search: "",
      searchItems: [],
      searchLoading: false
    };
  },
  components: {
    vHeaderNotifications: HeaderNotifications
  },
  computed: {
    searchIsEmpty: function() {
      return this.search === "" || this.search.length < 2;
    }
  },
  methods: {
    onUpdateSearch: _.debounce(function() {
      if (this.searchIsEmpty) {
        return false;
      }
      this.searchLoading = true;
      this.searchItems = [];
      let promise = this.$api
        .clearParams()
        .addParam("search", this.search)
        .get("search");

      promise
        .then(
          (response => {
            this.searchLoading = false;
            let searchItems = [];

            response.data.data.forEach(
              function(category) {
                if (category.type === "projectmanagers") {
                  category.type = "pms";
                }

                if (
                  ["projects", "customers", "pms"].indexOf(category.type) !== -1
                ) {
                  var searchItemResults = [];

                  category.results.forEach(
                    function(item) {
                      if (category.type === "projects") {
                        searchItemResults.push({
                          id: item.id,
                          title: item.title,
                          router: {
                            name: "customers-view-customer-project",
                            params: {
                              customer: item.customer,
                              project: item.id
                            }
                          }
                        });
                      } else if (category.type === "customers") {
                        searchItemResults.push({
                          id: item.id,
                          title: item.title,
                          router: {
                            name: "customers-view-customer",
                            params: { customer: item.id }
                          }
                        });
                      } else if (category.type === "pms") {
                        searchItemResults.push({
                          id: item.id,
                          title: item.title,
                          router: {
                            name: "customers-update-customer-pm",
                            params: {
                              customer: item.customer_id,
                              account: item.id
                            }
                          }
                        });
                      }
                    }.bind(this)
                  );

                  if (searchItemResults.length >= 1) {
                    searchItems.push({
                      label: this.$t(category.type),
                      type: category.type,
                      results: searchItemResults
                    });
                  }
                }
              }.bind(this)
            );

            this.searchItems = searchItems;
          }).bind(this)
        )
        .catch(
          (error => {
            this.searchItems = [];
          }).bind(this)
        );
    }, 500),
    onSearchItemClick: function() {
      this.search = "";
    }
  }
};
</script>
